import { Form } from 'app/components/form/form';
import { Validators } from '@angular/forms';

export class AddressForm extends Form {

  formErrors = {
    'title': {},
    'address': {},
    'taxNumber': {},
  };

  getInitForm = (title?: string,
                 address?: string,
                 taxNumber?: string) => {
    return {
      'title': [title, [Validators.required]],
      'address': [address, [Validators.required]],
      'taxNumber': [taxNumber, [Validators.required, Validators.maxLength(20), Validators.pattern(`^[a-zA-Z0-9\-]*$`)]]
    };
  };
}



// WEBPACK FOOTER //
// ./src/app/components/address-form/address.form.ts